import React from 'react';
import { Spin } from 'antd';
import * as S from './Spinner.styled';

const Spinner: React.FC = () => (
  <S.Spinner>
    <Spin />
  </S.Spinner>
);

export default Spinner;
